import { encode } from '..';
var panelTypeColorMapping = {
  info: '#deebff',
  note: '#eae6ff',
  success: '#e3fcef',
  warning: '#fffae6',
  error: '#ffebe6'
};
export var panel = function panel(node) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    context = _ref.context;
  var result = [];
  node.forEach(function (n) {
    result.push(encode(n, context));
  });
  return "{panel:bgColor=".concat(panelTypeColorMapping[node.attrs.panelType] || '', "}\n").concat(result.join('\n\n'), "\n{panel}");
};